var parseFormat = require('./lib/parseformat')
module.exports = parseFormat

/* istanbul ignore next */
if (typeof window !== 'undefined' && window.moment) {
  window.moment.parseFormat = parseFormat
}



//////////////////
// WEBPACK FOOTER
// /~/moment-parseformat/index.js
// module id = m0Xp
// module chunks = 0